var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckboxSelected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 3,
    fill: "#2D2D2D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.081 6.33103C16.3983 6.64833 16.421 7.1487 16.149 7.49215L16.081 7.56847L8.65641 14.9931C8.33911 15.3104 7.83874 15.3331 7.49529 15.0611L7.41897 14.9931L3.70666 11.2808C3.36495 10.9391 3.36495 10.385 3.70666 10.0433C4.02396 9.72604 4.52433 9.70338 4.86778 9.97535L4.9441 10.0433L8.03811 13.1365L14.8436 6.33103C15.1609 6.01373 15.6613 5.99106 16.0047 6.26304L16.081 6.33103Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckboxSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CheckboxSelected.2313be531555dd234303f554645327cb.svg";